import { UISpinner } from "@/shared/ui/ui-spinner";

import s from "./fallback-spinner.module.scss";

export const FallbackSpinner = () => (
	<div className={s.spinnerContainer}>
		<UISpinner spinning />
	</div>
);
